import { brand } from '@/lib/theme/tokens/palettes';

const Shadow = Object.freeze({
  low: `0 1px 3px 1px ${brand.blue.shades[4]}17`,
  mid: `0 3px 9px ${brand.blue.shades[4]}2e`,
  high: `0 6px 15px ${brand.blue.shades[4]}2e`,
});

export default Shadow;
